import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pillars = ['Nicho', 'Proveedor', 'Costos', 'Marca', 'Lanzamiento', 'Meta Ads'];
const tomos = [{
  n: 1,
  title: 'Mapa del Negocio de Ropa',
  desc: 'Modelos rentables en Argentina y cómo elegir el tuyo según tu capital inicial disponible hoy.'
}, {
  n: 2,
  title: 'Nicho Ganador 2026',
  desc: 'Cómo detectar rubros de alta demanda con baja competencia real usando Instagram, TikTok y Mercado Libre.'
}, {
  n: 3,
  title: 'Identidad de Marca',
  desc: 'Creá un concepto propio con nombre, estética y diferencial que no sea "una más del montón" en las redes.'
}, {
  n: 4,
  title: 'La Mini Cápsula',
  desc: 'Cómo diseñar tu colección inicial de 3 a 5 productos para validar demanda antes de producir en masa.'
}, {
  n: 5,
  title: 'Cacería de Proveedores',
  desc: 'Secretos para encontrar talleres y mayoristas serios que cumplan con calidad, tiempo y precio real.'
}, {
  n: 6,
  title: 'Costos y Márgenes Reales',
  desc: 'Ingeniería de precios para no perder contra la inflación. Fórmula exacta para saber cuánto cobrar siempre.'
}, {
  n: 7,
  title: 'Validación Lean',
  desc: 'Cómo testear tu producto con inversión mínima antes de fabricar cientos de unidades que podrían no venderse.'
}, {
  n: 8,
  title: 'Catálogo Visual con Celular',
  desc: 'Fotos y videos de alto impacto que generan ventas sin estudio profesional ni cámara cara.'
}, {
  n: 9,
  title: 'Tienda Online y Cobro Automático',
  desc: 'Configuración de tu canal de venta digital y cobro automático. Sin local, sin horarios, sin límites geográficos.'
}, {
  n: 10,
  title: 'Instagram y TikTok para Vender',
  desc: 'Estrategias de contenido orgánico que atrae clientes reales, no solo seguidores sin intención de compra.'
}, {
  n: 11,
  title: 'Meta Ads Express para Ropa',
  desc: 'Anuncios efectivos pensados para indumentaria. Vendé mientras dormís con presupuesto accesible desde el día uno.'
}, {
  n: 12,
  title: 'Hoja de Ruta 21 Días',
  desc: 'El plan de acción diario para tu primer lanzamiento real. De idea a "Venta Realizada" en tres semanas exactas.'
}];
const includes = ['Técnicas listas para aplicar', 'Protocolos paso a paso', 'Plantillas editables', 'Ejemplos del mercado ARG', 'Checklists de implementación', 'Cálculo con inflación real', 'Casos reales de emprendedores', 'Listo para aplicar desde hoy'];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-166" data-mp="2soyjh8fxnzj4">
      <div className="mx-auto max-w-6xl px-5 pt-[4px] pb-[28px]" data-id="element-167" data-mp="2sqje0y28zigz">
        <div className="pt-[14px] text-center" data-id="element-168" data-mp="2nqna0ytjvr1f">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-169" data-mp="32mmiiakknt73">
            🏆 MasterPack Marca Propia Argentina™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-170" data-mp="2xotbxgfcwx6a">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-171" data-mp="3h77alkhpup8g">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-172" data-mp="3la3zfsxunhku">
            {pillars.map(p => <span key={p} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-173" data-mp="37d8eb24bpzof">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-174" data-mp="32dm1gtseqlg5">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-celeste/50" data-id="element-175" data-mp="2omh9mdva6xgd" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-176" data-mp="3my9zmo0wbb5f">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-celeste/20 font-display text-lg font-black text-celeste-soft" data-id="element-177" data-mp="3hyp1ugxgp8ua">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-178" data-mp="385gi6x22cky4">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-179" data-mp="33653rup65rjp">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-gold/25 bg-ink-2 p-6" data-id="element-180" data-mp="2u705mphis082">
          <p className="text-center font-display text-lg font-black text-gold" data-id="element-181" data-mp="2p8yle18cxuv0">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-182" data-mp="sfdmfa3vd9m5">
            {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-183" data-mp="nin2gboy1tvg">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-celeste" strokeWidth={3} data-id="element-184" data-mp="uztcguaeqn34" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}